import { render, staticRenderFns } from "./LinkedIdsTable.vue?vue&type=template&id=122a8c30&scoped=true&"
import script from "./LinkedIdsTable.vue?vue&type=script&lang=js&"
export * from "./LinkedIdsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a8c30",
  null
  
)

export default component.exports